"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Thing = require("./Thing");

var _Thing2 = _interopRequireDefault(_Thing);

var _NavButtons = require("./NavButtons");

var _NavButtons2 = _interopRequireDefault(_NavButtons);

var _util = require("../util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SiteTable = function SiteTable(_ref) {
  var _ref$Thing = _ref.Thing,
      Thing = _ref$Thing === undefined ? _Thing2.default : _ref$Thing,
      _ref$NavButtons = _ref.NavButtons,
      NavButtons = _ref$NavButtons === undefined ? _NavButtons2.default : _ref$NavButtons,
      allChildren = _ref.allChildren,
      className = _ref.className,
      noNav = _ref.noNav,
      expanded = _ref.expanded,
      _ref$rank = _ref.rank,
      rank = _ref$rank === undefined ? 1 : _ref$rank,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ["Thing", "NavButtons", "allChildren", "className", "noNav", "expanded", "rank", "onClick"]);

  return _react2.default.createElement(
    "div",
    { className: "sitetable " + className, id: "siteTable", onClick: onClick },
    (allChildren || []).map(function (thing) {
      return thing && [(0, _util.optional)(Thing, _extends({}, props, thing, {
        expanded: expanded,
        key: thing.data.id || "unknown",
        data: _extends({}, thing.data)
      })), _react2.default.createElement("div", { className: "clearleft", key: (thing.data.id || "unknown") + "clear" })];
    }),
    noNav ? null : (0, _util.optional)(NavButtons, _extends({ allChildren: allChildren }, props))
  );
};

exports.default = SiteTable;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/SiteTable.js
// module id = 310
// module chunks = 0